import { LecBankAccount } from '../../lib/types/models/lec-bank-account/lec-bank-account'
import { LecBankAccountInput } from '../../lib/types/models/lec-bank-account/lec-bank-account-input'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createLecBankAccount(data: LecBankAccountInput) {
  return restApiClient
    .url(API.lecBankAccounts.create.url)
    .post<LecBankAccount, LecBankAccountInput>(data)
}
